import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import moment from 'moment'

import {
  injectIntl,
} from 'react-intl'

import {
  deleteApiKey,
} from '../../../actions/actions'

import notificationStyles from '../../../../css/notifications.module.css'
import styles2 from '../../../../css/settings.module.css'

Modal.setAppElement('#app')

const convertPermissions = function convertPermissions (level) {
  if (level === 20 || level === '20') {
    return 'Administrator'
  }
  return 'Manager'
}

const getUserName = function getUserName (item) {
  if (item.user_email) {
    if (item.user_email.includes('@semios') || item.user_email.includes('@altrac')) {
      return 'Altrac Support'
    }
  }

  if (item.user_name) {
    return item.user_name
  } if (item.user_email) {
    return item.user_email
  }
  return 'N/A'
}

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(196, 196, 196, 0.8)',
    zIndex: 100,
  },
  content: {
    top: '50%',
    left: '50%',
    maxWidth: '400px',
    minWidth: '300px',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    borderRadius: '10px',
    boxShadow: 'none',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    color: '#284047',
    textAlign: 'center',
  },
}

const ApiKey = ({ customerApiKeys, formatMessage, getData, customerID }) => {
  const [warningModalIsOpen, setWarningModalIsOpen] = useState(false)
  const [modalCurrentName, setModalCurrentName] = useState('')
  const [modalCurrentApiID, setModalCurrentApiID] = useState('')
  const [deleteError, setDeleteError] = useState(false)

  const closeWarningModal = () => {
    setWarningModalIsOpen(false)
  }

  const openWarningModal = (apiName, id) => {
    setWarningModalIsOpen(true)
    setModalCurrentName(apiName)
    setModalCurrentApiID(id)
  }

  const deleteKey = (applicationID) => {
    deleteApiKey(
      applicationID,
      (error) => {
        if (error) {
          setDeleteError(true)
        } else {
          setTimeout(() => {
            getData(customerID)
            closeWarningModal()
          }, 500)
        }
      }
    )
  }

  const data = customerApiKeys.items || []

  const warningModalHeader = formatMessage({
    id: 'settings.warnings.deleteHeader',
    defaultMessage: 'Delete',
    description: 'WARNING: Confirm Delete Header',
  })

  const warningModalText = formatMessage({
    id: 'settings.warnings.deleteText',
    defaultMessage: 'Are you sure you want to delete?',
    description: 'WARNING: Confirm delete text',
  })

  const {
    modalHeadWarning,
    modalDeleteButton,
    transferSave,
    modalCancelDeleteButton,
    modalHeadCenter,
  } = notificationStyles

  return (
    <div>
      <p className={styles2.apiWarningText}>
        {formatMessage({
          id: 'support.api.note',
          defaultMessage: 'Note: A limit of three Altrac API keys are allowed to be created at a time.  If more are required please contact Altrac Support.',
        })}
      </p>

      {data.map((item) => (
        <div key={item.id} className={styles2.apiItemWrapper}>
          <div className={styles2.apiHeaderContainer}>
            <h3>{item.name}</h3>
            <button
              type='button'
              onClick={() => { openWarningModal(item.name, item.id) }}
            >
              {formatMessage({
                id: 'support.api.delete',
                defaultMessage: 'Delete',
              })}
            </button>
          </div>
          <div className={styles2.apiContainer}>
            <section className={styles2.apiInside}>
              <div className={styles2.apiInfoLeft}>
                <div>
                  <h3>
                    {formatMessage({
                      id: 'support.api.keyid',
                      defaultMessage: 'Key ID',
                    })}
                  </h3>
                  <p>{item.client_id}</p>
                </div>
                <div>
                  <div>
                    <h3>
                      {formatMessage({
                        id: 'support.api.createdby',
                        defaultMessage: 'Created By',
                      })}
                    </h3>
                    <p className={styles2.noBorder}>
                      {getUserName(item)}
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles2.apiInfoRight}>
                <div>
                  <h3>
                    {formatMessage({
                      id: 'support.api.permissions',
                      defaultMessage: 'Permissions',
                    })}
                  </h3>
                  <p>{convertPermissions(item.permissions.level)}</p>
                </div>
                <div>
                  <div>
                    <h3>
                      {formatMessage({
                        id: 'support.api.createdon',
                        defaultMessage: 'Created On',
                      })}
                    </h3>
                    <p className={styles2.noBorder}>{moment(item.created_at).format('L')}</p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      ))}

      <Modal
        isOpen={warningModalIsOpen}
        onRequestClose={closeWarningModal}
        style={customStyles}
        contentLabel='warningModal'
      >
        <h3 className={`${modalHeadWarning} ${modalHeadCenter}`}>
          {warningModalHeader}
          {' '}
          {modalCurrentName}
        </h3>
        <p className={`${modalHeadWarning} ${modalHeadCenter}`}>{warningModalText}</p>
        <h3 className={`${transferSave}`}>
          <button
            type='button'
            className={`${modalDeleteButton}`}
            style={{ textTransform: 'uppercase' }}
            onClick={() => { deleteKey(modalCurrentApiID) }}
          >
            {formatMessage({
              id: 'general.deleteConfirm',
              defaultMessage: 'Delete',
            })}
          </button>
          <button
            className={`${modalCancelDeleteButton}`}
            style={{ textTransform: 'uppercase' }}
            onClick={closeWarningModal}
            type='button'
          >
            {formatMessage({
              id: 'general.cancel',
              defaultMessage: 'Cancel',
            })}
          </button>
        </h3>
      </Modal>
    </div>
  )
}

ApiKey.propTypes = {
  customerApiKeys: PropTypes.shape({
    items: PropTypes.array,
  }),
  formatMessage: PropTypes.func.isRequired,
  getData: PropTypes.func.isRequired,
  customerID: PropTypes.string.isRequired,
}

export default injectIntl(ApiKey)
